<script setup lang="ts">
import { formatDate } from "@library/Utilities";
import { useAppConfiguration } from "@domain/AppConfiguration";
import type { IAppointment } from "@domain/Appointment/IAppointment";

const { openBookings } = defineProps<{ openBookings: IAppointment[] }>();
const appConfiguration = useAppConfiguration();
</script>

<template>
    <div v-if="openBookings.length > 0">
        <div class="uppercase pt-5 pb-2 3xl:pb-4 px-4 text-sm lg:text-base 3xl:text-lg grid grid-cols-5 bg-gray-850">
            <span class="col-span-4">Upcoming Bookings</span>
        </div>
        <div v-for="item in openBookings"
            class="bg-white dark:bg-gray-800 py-4 px-4 mb-0.5 last:mb-0 grid grid-cols-5 items-center">
            <div class="col-span-4 tracking-wider">
                <div class="text-base 3xl:text-lg">{{ item.title }}</div>
                <div class="text-sm 3xl:text-base opacity-60">
                    {{ appConfiguration.serviceLocation.name }}
                </div>
            </div>
            <div class="col-span-1 text-right">
                <div class="text-sm 3xl:text-base opacity-60">
                    {{ formatDate(item.utcDateCreated) }}
                </div>
            </div>
        </div>
    </div>
</template>
